/**
 * Iniciales de una PERSONA a partir de su nombre visible.
 *
 * La API ya devuelve `iniciales` calculadas en la mayoría de los recursos
 * (`personas`, el usuario de sesión, la papelera), y donde exista ese campo hay
 * que usarlo: esta función es para las pantallas que sólo reciben el nombre
 * armado en un string —la bandeja de documentos y el avance de capacitaciones—
 * y no tienen de dónde sacarlo.
 *
 * Existía dos veces, una en cada una de esas pantallas, y las dos versiones NO
 * hacían lo mismo: una tomaba la inicial de las dos primeras palabras y la otra
 * concatenaba la inicial de TODAS y después cortaba a dos. Para "Juan Pablo
 * Soto" coincidían; para un nombre con partícula ("Juan de la Cruz") una decía
 * "JD" y la otra "JD" pero por motivos distintos, y cualquier cambio futuro en
 * una no llegaba a la otra. Un solo lugar es lo que impide que vuelvan a
 * divergir.
 *
 *   "Juan Pablo Soto" → "JP"
 *   "Agentic0"        → "AG"   (una sola palabra: sus dos primeros caracteres)
 *   ""                → "—"
 *
 * Nunca una sola letra, salvo que el nombre entero mida uno. Es el mismo
 * contrato que `inicialesEmpresa()` en `empresa-marca.ts`, y por el mismo
 * motivo: un avatar con una letra sola se lee como un error de datos.
 */
export function inicialesPersona(nombre?: string | null): string {
  const fuente = (nombre ?? "").trim();
  if (!fuente) return "—";

  const palabras = fuente.split(/\s+/).filter(Boolean);
  // Se recorre por code point y no por índice de string: `slice(0, 2)` parte al
  // medio un carácter fuera del plano básico y deja media unidad suelta.
  const letras =
    palabras.length >= 2
      ? [...palabras[0]][0] + [...palabras[1]][0]
      : [...palabras[0]].slice(0, 2).join("");

  return letras.toUpperCase();
}
